import { useAuth0 } from '@auth0/auth0-vue'
import { unref } from 'vue'
import { RouteLocationNormalized } from 'vue-router'

/**
 * Route guard that requires a known identity — either an authenticated
 * session (entity id) or an external id via the `tc` query param (or sessionStorage).
 * Redirects to login if neither is present. Used for unauthenticated routes that still require an identity.
 * @param to
 */
export async function identityGuard(to: RouteLocationNormalized) {
  if (to.query.tc || window.sessionStorage.getItem('tc')) {
    return true
  }

  const client = useAuth0()
  if (!unref(client.isAuthenticated)) {
    await client.checkSession()
  }

  if (unref(client.isAuthenticated)) {
    return true
  }

  return {
    name: '#loginMethod',
    query: { redirect: to.fullPath },
  }
}
